export function UserIcon({ active }: { active: boolean }) {
  const color: any = active ? "#006AB3" : "#8D9091";
  return (
    <svg
      width="42"
      height="34"
      viewBox="0 0 42 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.7383 18.1062C29.8415 19.7774 31.5359 22.2017 32.5898 25.0821C38.1163 24.8 42.0004 23.4637 42.0004 23.4637C42.0004 18.2871 39.8533 13.749 36.6305 11.209C35.2134 12.9232 33.071 14.0158 30.6733 14.0158C29.9349 14.0158 29.2208 13.9118 28.5445 13.7183C28.5769 14.0041 28.5941 14.2945 28.5941 14.5889C28.5942 15.8573 28.285 17.0533 27.7383 18.1062Z"
        fill={color}
      />
      <path
        d="M14.1602 18.107C13.6135 17.054 13.3042 15.858 13.3042 14.5896C13.3042 14.2959 13.3214 14.0062 13.3536 13.7211C12.7078 13.8962 12.0285 13.9904 11.3272 13.9904C8.92948 13.9904 6.78687 12.8978 5.36987 11.1836C2.14704 13.7235 0 18.2616 0 23.4383C0 23.4383 3.76599 24.792 9.3163 25.0619C10.3707 22.1907 12.0621 19.7741 14.1602 18.107Z"
        fill={color}
      />
      <path
        d="M32.2764 31.7626C32.2764 26.5859 30.1294 22.0478 26.9066 19.5078C25.4895 21.222 23.347 22.3146 20.9493 22.3146C18.5516 22.3146 16.409 21.222 14.992 19.5078C11.7692 22.0478 9.62207 26.5859 9.62207 31.7626C9.62207 31.7626 14.2678 33.433 20.8449 33.433C27.4219 33.433 32.2764 31.7626 32.2764 31.7626Z"
        fill={color}
      />
      <path
        d="M20.9494 20.852C24.4089 20.852 27.2133 18.0475 27.2133 14.5881C27.2133 11.1287 24.4089 8.32422 20.9494 8.32422C17.49 8.32422 14.6855 11.1287 14.6855 14.5881C14.6855 18.0475 17.49 20.852 20.9494 20.852Z"
        fill={color}
      />
      <path
        d="M30.6722 0.0263672C27.2127 0.0263672 24.4082 2.83073 24.4082 6.29024C24.4082 6.83876 24.4793 7.37063 24.6117 7.87764C26.2468 8.77206 27.5189 10.2467 28.1519 12.0247C28.9232 12.3642 29.7752 12.554 30.6722 12.554C34.1315 12.554 36.936 9.74967 36.936 6.29016C36.936 2.83065 34.1315 0.0263672 30.6722 0.0263672Z"
        fill={color}
      />
      <path
        d="M17.3874 7.84968C17.5195 7.34309 17.5903 6.81181 17.5903 6.26388C17.5903 2.80437 14.7858 0 11.3265 0C7.86695 0 5.0625 2.80437 5.0625 6.26388C5.0625 9.72338 7.86695 12.5277 11.3265 12.5277C12.2039 12.5277 13.0389 12.3466 13.7971 12.0208C14.4371 10.226 15.7286 8.74059 17.3874 7.84968Z"
        fill={color}
      />
    </svg>
  );
}
